'use client';

import { BeachVolleyballMatchModel } from '@nf/types/odds';
import { ScoreboardColumn } from './scoreboard-column';
import { RainIcon, RedCrossIcon, TicketRunningIcon } from '@/components/icons/svg-icons';
import { scoreboardService } from '@/services/scoreboard.service';
import { BeachVolleyballLiveScore } from '@nf/types/scoreboard';
import { ScoreboardData } from '@/types/scoreboard-settings';
import { TotalBoard } from './scoreboard-totalboard';
import { useTranslations } from 'next-intl';
import { Styles } from './scoreboard.style';
import { cx } from 'styled-system/css';

// 沙灘排球
export const ScoreboardSp45 = ({ beachVolleyballMatchModel }: { beachVolleyballMatchModel: BeachVolleyballMatchModel }) => {
	const t = useTranslations('General');
	const getTitle = (type: string, round?: number) => {
		let resourceKey = '';
		if (type === 'set') {
			switch (round) {
				case 1:
					resourceKey = t('lbl_Volley_S1');
					break;
				case 2:
					resourceKey = t('lbl_Volley_S2');
					break;
				case 3:
					resourceKey = t('lbl_Volley_S3');
					break;
				case 4:
					resourceKey = t('lbl_Volley_S4');
					break;
				case 5:
					resourceKey = t('lbl_Volley_S5');
					break;
			}
		} else if (type === 'gamePoint') {
			resourceKey = t('lbl_Volley_Set');
		} else {
			resourceKey = t('livescoreHeader_TPts');
		}
		return resourceKey;
	}

	const hideColumn = (round: number) => {
		switch (round) {
			case 4:
			case 5:
				return ls._gs !== '5';
		}
	}

	const ls = beachVolleyballMatchModel.ls;
	const beachVolleyballScoreboardSetting = scoreboardService.getScoreboardSetting(beachVolleyballMatchModel.GameID).boardColumn;
	const beachVolleyballScoreboardOption = scoreboardService.getScoreboardSetting(beachVolleyballMatchModel.GameID).options;
	const beachVolleyballScoreboardData: ScoreboardData[] = [];
	const trn = ls[beachVolleyballScoreboardOption.trn as keyof BeachVolleyballLiveScore];

	beachVolleyballScoreboardSetting.forEach((setting) => {
		if (hideColumn(setting.round ?? 0)) {
			return;
		}
		switch (setting.type) {
			case 'gamePoint':
				const gamePointhomeScore = ls[setting.keyValue?.[0] as keyof BeachVolleyballLiveScore]
				const gamePointawayScore = ls[setting.keyValue?.[1] as keyof BeachVolleyballLiveScore]
				beachVolleyballScoreboardData.push({
					heading: getTitle(setting.type, setting.round ?? 0),
					cells: [
						{ text: gamePointhomeScore },
						{ text: gamePointawayScore }
					]
				});
				break;
			case 'set':
				let homeScore: string;
				let awayScore: string;
				if (parseInt(ls.llp, 10) >= (setting.round ?? 0)) {

					homeScore = ls[setting.keyValue?.[0] as keyof BeachVolleyballLiveScore];
					awayScore = ls[setting.keyValue?.[1] as keyof BeachVolleyballLiveScore];
				} else {
					homeScore = '-';
					awayScore = '-';
				}

				beachVolleyballScoreboardData.push({
					heading: getTitle(setting.type, setting.round ?? 0),
					cells: [
						{ text: homeScore },
						{ text: awayScore }
					]
				});
				break;
			case 'total':
				beachVolleyballScoreboardData.push({
					heading: 'total',
					cells: [
						{ text: setting.keyValue ? ls[setting.keyValue?.[0] as keyof BeachVolleyballLiveScore] : '-' },
						{ text: setting.keyValue ? ls[setting.keyValue?.[1] as keyof BeachVolleyballLiveScore] : '-' }
					]

				});
				break;
		}

	});

	return (
		<>
			<div className={cx('scoreboard scoreboard--sport45', Styles.scoreboard)}>
				<div className="scoreboard__col-event">
					<div className="scoreboard__cell-heading">
						{
							ls.rain === '1' ? <RainIcon /> : null
						}
					</div>
					<div className="scoreboard__cell" data-current={trn === '1'}>
						<TicketRunningIcon />
						<span className="scoreboard__text">{t('lbl_ShortH')}</span>
						{
							ls.inj === '3' || ls.inj === '2' ?
								<span className="scoreboard__status-injury"><RedCrossIcon /></span> : null
						}
					</div>
					<div className="scoreboard__cell" data-current={trn === '2'}>
						<TicketRunningIcon />
						<span className="scoreboard__text">{t('lbl_ShortA')}</span>
						{
							ls.inj === '3' || ls.inj === '1' ?
								<span className="scoreboard__status-injury"><RedCrossIcon /></span> : null
						}
					</div>
				</div>
				{
					beachVolleyballScoreboardData.map((column, index) => {
						if (column.heading === 'total') {
							return;
						}
						if (index === 0) {
							return (
								<div key={index} className="scoreboard__col-total">
									<ScoreboardColumn
										key={index}
										heading={column.heading}
										cells={column.cells}
									/>
								</div>
							)
						} //GamePoint判斷
						return (
							<div key={`${column.cells}${index}`} className="scoreboard__col">
								<ScoreboardColumn
									key={`${index}${beachVolleyballMatchModel.MatchId}Column`}
									heading={column.heading}
									cells={column.cells}
								/>
							</div>
						)

					})}
				<div className="scoreboard__col-total">
					<div className="scoreboard__cell-heading">
						<span className="scoreboard__text">{getTitle('total')}</span>
					</div>
					{
						beachVolleyballScoreboardData.find(x => x.heading === 'total')?.cells?.map((cell, index) => (
							<TotalBoard
								key={`${index}${beachVolleyballMatchModel.MatchId}TotalScore`}
								totalScore={cell.text}
							/>
						))
					}
				</div>
			</div>
		</>
	);
};
